// extracted by mini-css-extract-plugin
module.exports = {"progressHeader":"style_progressHeader__2hx6H","progressDashboard":"style_progressDashboard__gOFKU","hasFilters":"style_hasFilters__1CXbU","heading":"style_heading__pGzRm"};